import { USER_LOGIN } from '../actions'

export default function (state = '', action) {
    switch (action.type) {
        case USER_LOGIN:
            if (action.error == true) {
                if (action.payload.response.status == 401) {
                    return { success: false, msg: 'กรุณาตรวจสอบ Username และ Password' }
                }
            }
            else {
                return action.payload.data
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user_reducer.js